// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
